import { useEffect, useRef } from 'react';

interface WakeLockSentinel {
    release(): Promise<void>;
}

interface WakeLock {
    request(type: 'screen'): Promise<WakeLockSentinel>;
}

declare global {
    interface Navigator {
        wakeLock?: WakeLock;
    }
}

export function useWakeLock(): void {
    const wakeLockRef = useRef<WakeLockSentinel | null>(null);

    useEffect(() => {
        let isActive = true;

        async function requestWakeLock() {
            if (!navigator.wakeLock) {
                return;
            }
            try {
                const sentinel = await navigator.wakeLock.request('screen');
                if (isActive) {
                    wakeLockRef.current = sentinel;
                } else {
                    sentinel.release();
                }
            } catch {
                // Wake lock request failed (e.g., low battery, tab not visible) — proceed silently
            }
        }

        requestWakeLock();

        return () => {
            isActive = false;
            wakeLockRef.current?.release();
            wakeLockRef.current = null;
        };
    }, []);
}
